app.controller('surveysController', function($http, $scope, $stateParams, $location, dataService, DTColumnBuilder, pageConfig, pageHandler, $timeout, $modal, $anchorScroll, $controller, anchorSmoothScroll, $window) {

	//Include custom controller functionality
	$controller('userDefinedSurveysController', {$scope: $scope, $stateParams: $stateParams});
	
	//initialise survey specific views
	pageHandler.initViews(pageConfig, $scope);

	//initialise filters
	var filtersLoaded = pageHandler.initFilters(pageConfig, $scope);
	
	if(filtersLoaded)
	{	
		//initialise components
		pageHandler.initComponents(pageConfig, $scope);
	
		//show loading on components
		pageHandler.showLoading(pageConfig, $scope);
	
		//request data for components
		pageHandler.requestDataForComponents(pageConfig, $scope);
		
		//initialize export feature
		pageHandler.initPageExports(pageConfig, $scope);
	}
	
	//=======page specific methods and processes==========//
	
	//show transcript
	$scope.showTranscript = function(rowData, component, componentKey)
	{
		$('.hide_on_transcript').hide();
		//flag to switch on transcript view
		$scope.transcript = 1;
		$scope.can_access_appeal = false;
		var selectkey = component.config.click_key;
		var selectsurveykey = typeof(component.survey_key != 'undefined') ? component.survey_key : null;

		//add survey id to URL
		$location.hash(rowData[selectkey]);
		
		//Get data for transcript
		$scope[componentKey].selectedRowData = {};
		
		var post_data = {};
		post_data['selectkey'] = selectkey;
		post_data['selectvalue'] = (typeof(rowData[selectkey]) != 'undefined') ? rowData[selectkey] : null;
		post_data['selectsurveyvalue'] = (typeof(selectsurveykey) != 'undefined') ? selectsurveykey : null;
		post_data['app_state'] = $scope.appState;
		
		//add selected survey details to scope for other operations in the page (e.g. hot alert form)
		$scope.pageState= {};
		$scope.pageState.selectkey = post_data['selectkey'];
		$scope.pageState.selectvalue = post_data['selectvalue'];
		$scope.pageState.selectsurveyvalue = post_data['selectsurveyvalue'];

		$scope.rowData = rowData;
		$scope.component = component;
		$scope.componentKey = componentKey;
		//$scope.files = {};

		dataService.getData(component.config.rowclick_url, post_data , 'POST')
			.then(function(response) {
				if(typeof(response.data) != 'undefined')
				{	
					$scope.appeal_doc_download_url = $location.absUrl().split('#')[0]+'/common/document_download';

					if(typeof(response.data.details) != 'undefined')
					{	
						$scope[componentKey].selectedRowData.details = response.data.details;
					}
					if(typeof(response.data.summary) != 'undefined')
					{	
						$scope[componentKey].selectedRowData.summary = response.data.summary;
					}
					if(typeof(response.data.hot_alert_details) != 'undefined')
					{	
						if(typeof(response.data.hot_alert_details.hot_alert.id) != 'undefined') {
							$scope.pageState.hotAlertId = response.data.hot_alert_details.hot_alert.id;
						}
						if(typeof(response.data.hot_alert_details.hot_alert.hot_alert_status) != 'undefined') {
							$scope.hotAlertStatus = response.data.hot_alert_details.hot_alert.hot_alert_status;
						}
						$scope[componentKey].selectedRowData.hot_alert_details = response.data.hot_alert_details;
						$scope.hotAlertId = (typeof(response.data.hot_alert_details.hot_alert.id) != 'undefined') ? response.data.hot_alert_details.hot_alert.id : null;
						$scope.hotAlertComments = (typeof(response.data.hot_alert_details.comments) != 'undefined') ? response.data.hot_alert_details.comments : null;
						$scope.hotAlertDetails = (typeof(response.data.hot_alert_details.hot_alert) != 'undefined') ? response.data.hot_alert_details.hot_alert : null;
						$scope.hot_alert_display = (typeof(response.data.hot_alert_display) != 'undefined') ? response.data.hot_alert_display : false;
					}
					if(typeof(response.data.appeal_details) != 'undefined')
					{	
						if(typeof(response.data.appeal_details.appeal.id) != 'undefined') {
							$scope.pageState.appealId = response.data.appeal_details.appeal.id;
						}
						$scope.canActionAppeal = (typeof(response.data.can_action_appeal) != 'undefined') ? response.data.can_action_appeal : false;
						$scope.canSubmitAppeal = (typeof(response.data.can_submit_appeal) != 'undefined') ? response.data.can_submit_appeal : false;
						$scope.canViewAppeal = (typeof(response.data.can_view_appeal) != 'undefined') ? response.data.can_view_appeal : false;

						$scope.appealDetails = (typeof(response.data.appeal_details.appeal) != 'undefined') ? response.data.appeal_details.appeal : null;
						$scope.appealComments = (typeof(response.data.appeal_details.comments) != 'undefined') ? response.data.appeal_details.comments : null;
						$scope.appealDocuments = (typeof(response.data.appeal_details.uploads) != 'undefined') ? response.data.appeal_details.uploads : null;
						$scope.appealTypes = (typeof(response.data.appeal_details.appeal_types) != 'undefined') ? response.data.appeal_details.appeal_types : null;
						$scope.appealTypeSelected = null;
						$scope.appealCategories = (typeof(response.data.appeal_details.appeal_categories) != 'undefined') ? response.data.appeal_details.appeal_categories : null;

						if($scope.appealTypes != null)
						{
							var first_appeal_type = Object.keys($scope.appealTypes)[0];
							$scope.appealTypeSelected = first_appeal_type;
							if(typeof($scope.appealTypes[first_appeal_type]) != 'undefined')
							{
								$scope.appealCategories = $scope.appealTypes[first_appeal_type];
							}
						}

						$scope.showAppealForm = (response.data.appeal_details.appeal_form_display != 'HIDE' && response.data.appeal_details.appeal_form_display != 'EXPIRED') ? true : false;
						$scope.appealSubmitEmail = (typeof(response.data.appeal_details.to_email_address) != 'undefined') ? response.data.appeal_details.to_email_address : '';
						$scope.notifyEmail = (typeof(response.data.appeal_details.notify_email) != 'undefined') ? response.data.appeal_details.notify_email : false;

						if(typeof(response.data.appeal_details.allowed_extension) != 'undefined') {
							$scope.allowedExtension = response.data.appeal_details.allowed_extension;
						}
						if(typeof(response.data.appeal_details.allowed_max_size) != 'undefined') {
							$scope.allowedMaxSize = response.data.appeal_details.allowed_max_size;
						}
						if(typeof(response.data.appeal_details.max_num_files_allowed) != 'undefined') {
							$scope.maxNumFilesAllowed = response.data.appeal_details.max_num_files_allowed;
						}
						if(typeof(response.data.appeal_details.min_num_files_allowed) != 'undefined') {
							$scope.minNumFilesAllowed = response.data.appeal_details.min_num_files_allowed;
						}

						$scope[componentKey].selectedRowData.appeal_details = response.data.appeal_details;
						$scope[componentKey].commentsCount = Object.keys(response.data.appeal_details.comments).length;
					}
					if(typeof(response.data.additional) != 'undefined')
					{	
						$scope[componentKey].selectedRowData.additional = response.data.additional;
						
						//convert objects to array for display
						if(typeof(response.data.additional) != 'undefined')
						{	
							var additionalData = []; 
							$.each(response.data.additional, function(key, value)
	        				{
								//do not store status as its already shown outside ng-repeat
								if(key == 'app_metric_hot_alert_status')
								{
									return true;
								}	
								
								additionalData.push(value);
								if(typeof(value['hot_alert_display']) != 'undefined')
								{
									$scope.hot_alert_display = value['hot_alert_display'];
								}
	        				});
							
							$scope[componentKey].selectedRowData.additionalData = additionalData;
						}
					}
					$scope.can_access_appeal = (typeof(response.data.can_access_appeal) != 'undefined') ? response.data.can_access_appeal : false;

				}
			}
		);
		
	}
	
	//hide transcript
	$scope.hideTranscript = function() {

		//Go to base url, if transcript filter have value
		var submenu_key = $scope['appState']['submenu_key'];
		var filter_transcript_key = 'filter_transcript_' + submenu_key;
		if (typeof $scope[filter_transcript_key] != 'undefined' &&
			typeof $scope[filter_transcript_key]['selected_value'] != 'undefined' &&
			$scope[filter_transcript_key]['selected_value'] !== '') {

			var filter_transcript_return_key = 'filter_transcript_return_' + submenu_key;
			if(typeof $scope[filter_transcript_return_key] != 'undefined' &&
				typeof $scope[filter_transcript_return_key]['selected_value'] != 'undefined' &&
				$scope[filter_transcript_return_key]['selected_value'] !== '') {
				var filter_transcript_return = JSON.parse(window.decodeURI($scope[filter_transcript_return_key]['selected_value']));
				$scope.goToPage(filter_transcript_return.page, {}, filter_transcript_return.submenu_key);
			} else {
				var url = $location.absUrl().split('#')[0];
				$window.location.href = url;
			}
		}

		$('.hide_on_transcript').show();
		//flag to switch on survey view
		$scope.transcript = 0;

		if($('.default_hide').length > 0)
		{
			$('.default_hide').hide();
		}

		if($("#appeal_submit_form").length > 0)
		{
			$('#appeal_submit_form')[0].reset();
		}
		
		if($("#hot_alert_submit_form").length > 0)
		{
			$('#hot_alert_submit_form')[0].reset();
		}

		$('.panel .panel-heading .fa-chevron-up').toggleClass('fa-chevron-down');
      	$('.panel .panel-heading .fa').removeClass('fa-chevron-up');
		
		//move to the previous scroll psoition
		$timeout(function(){$anchorScroll();}, 300);
	}

	$scope.showCategoryBasedOnAppealType = function(type)
	{
		$scope.appealCategories = null;
		if(typeof($scope.appealTypes[type]) != 'undefined')
		{
			$scope.appealCategories = $scope.appealTypes[type];
		}
	}
	
	
	//show hot alert
	$scope.showHotAlert = function(hotAlertDivId)
	{
		$location.hash(hotAlertDivId);
      	anchorSmoothScroll.scrollTo(hotAlertDivId);
      	$('#'+hotAlertDivId+' .panel-body').show();
      	$('#'+hotAlertDivId+' .panel .panel-heading .fa-chevron-down').toggleClass('fa-chevron-up');
      	$('#'+hotAlertDivId+' .panel .panel-heading .fa-chevron-up').removeClass('fa-chevron-down');
		
	}

	//show appeals form. params are url, componentKey and div id to reach the scroll
	$scope.showAppealsForm = function(appealDivId)
	{
		$location.hash(appealDivId);
      	anchorSmoothScroll.scrollTo(appealDivId);
      	$('#'+appealDivId+' .panel-body').show();
      	$('#'+appealDivId+' .panel .panel-heading .fa-chevron-down').toggleClass('fa-chevron-up');
      	$('#'+appealDivId+' .panel .panel-heading .fa-chevron-up').removeClass('fa-chevron-down');
	}

	//Open survey transcript, if transcript filter have value
	var submenu_key = $scope['appState']['submenu_key'];
	var filter_transcript_key = 'filter_transcript_' + submenu_key;
	if (typeof $scope[filter_transcript_key] != 'undefined') {
		var filter_transcript = $scope[filter_transcript_key];
		if(typeof filter_transcript['selected_value'] != 'undefined' &&
			filter_transcript['selected_value'] !== '' &&
			typeof filter_transcript['survey_component'] != 'undefined' &&
			typeof filter_transcript['key_metric'] != 'undefined') {

			var selected_value = filter_transcript['selected_value'];
			var metric = filter_transcript['key_metric'];
			var rowData = [];
			rowData[metric] = selected_value;

			var componentKey = filter_transcript['survey_component'];
			if(typeof pageConfig.components[componentKey] != 'undefined' && rowData) {
				var component = pageConfig.components[componentKey];

				if (rowData) {
					$scope.showTranscript(rowData, component, componentKey);
				}
			}
		}
	}
	
});
